import { Form, Switch, Typography } from 'antd'
import {LockOutlined, UnlockOutlined} from "@ant-design/icons"
export const MySwitch = ({withoutForm, name, label, tooltip, type, size, disabled, required, message, checked, validator, ...props }) => {
   
    return (
        <>
            {
                withoutForm ?
                  <Switch
                    checkedChildren={<LockOutlined />}
                    unCheckedChildren={<UnlockOutlined />}
                    checked={checked}
                    size={size || 'middle'}
                    disabled={disabled || false}
                    {...props}
                  />
                :
                <Form.Item
                    name={name}
                    label={<Typography.Text strong>{label}</Typography.Text>}
                    tooltip={tooltip || null}
                    rules={validator ? [
                        {
                            required: required,
                            message: message,
                        },
                        validator
                    ] : [
                        {
                            required: required,
                            message: message,
                        },
                    ]}
                >
                  <Switch
                    checkedChildren={<LockOutlined />}
                    unCheckedChildren={<UnlockOutlined />}
                    checked={checked}
                    size={size || 'middle'}
                    disabled={disabled || false}
                    {...props}
                  />
                </Form.Item>

            }
        </>
    )
}